import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

function ContributionForm({ role_id, candidate_id, onClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    getValues,
  } = useForm({
    defaultValues: { score: {} },
  });

  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [data, setData] = useState([]);
  const [averages, setAverages] = useState({});

  const handleCheckboxChange = (e, userId, totalKra) => {
    setAverages((prev) => {
      const prevChecked = prev[userId]?.checked || 0;
      const newChecked = e.target.checked ? prevChecked + 1 : prevChecked - 1;

      const average = newChecked / totalKra;
      const newAvg = Math.max(0, average);

      setValue(`score.${userId}`, Number(newAvg.toFixed(1)));

      return {
        ...prev,
        [userId]: {
          checked: newChecked,
          average: newAvg,
        },
      };
    });
  };

  const get_all_details = async () => {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/workstation/get_contribution_form/${role_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setData(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    get_all_details();
  }, []);

  const onsubmit = async (formData) => {
    const scoreObj = getValues("score");

    const invalidWorkers = data?.roleWorker?.filter(
      (worker) =>
        !scoreObj[worker.user_id] || Number(scoreObj[worker.user_id]) === 0
    );

    if (invalidWorkers.length > 0) {
      invalidWorkers.forEach((worker) => trigger(`score.${worker.user_id}`));
      return alert(
        "Please select at least one contribution area for each worker."
      );
    }
    formData = { role_id, candidate_id, score: scoreObj, user: formData.user };

    // if you want to submit

    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/workstation/add_contribution_form`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(response);
      if (response.status === 200) {
        onClose(1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <form onSubmit={handleSubmit(onsubmit)}>
              <div className="modal-header">
                <h4 className="modal-title">
                  <b>Role Contribution</b>
                </h4>
                <button
                  type="button"
                  onClick={onClose}
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="table-responsive mb-4">
                  <table className="table table-hover mb-0">
                    <thead>
                      <tr>
                        <td className="text-primary">CONTRIBUTION AREA</td>
                        {data?.roleWorker?.map((item, index) => (
                          <td className="text-primary" key={index}>
                            {`${item.firstname} ${item.lastname}`}
                          </td>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data?.rolekra?.map((kra, kraIndex) => (
                        <tr key={kraIndex}>
                          <td>{kra.name}</td>
                          {data?.roleWorker?.map((worker, workerIndex) => (
                            <td key={workerIndex}>
                              <input
                                type="checkbox"
                                className="form-check"
                                {...register(
                                  `user.u_${worker.user_id}.kra_${kra.id}`
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    worker.user_id,
                                    data.rolekra.length
                                  )
                                }
                              />
                            </td>
                          ))}
                        </tr>
                      ))}

                    {/* Average & hidden score rows */}
                    <tr>
                      <td></td>
                      {data?.roleWorker?.map((worker) => (
                        <td key={`avg_${worker.user_id}`} className="text-left">
                          {averages[worker.user_id]?.average?.toFixed(1) || "0.0"}
                          <input type="hidden" {...register(`score.${worker.user_id}`)}
                            value={averages[worker.user_id]?.average?.toFixed(1) || "0.0"}
                            readOnly
                          />
                        </td>
                      ))}
                    </tr>
                    </tbody>
                  </table>
                </div>
                <p>
                  Please note: All resources will receive a complete closure.
                  Closure contribution is an indication of work done in this
                  particular role.
                  <br />
                  This will help us identify gaps in learning, tracking
                  real-time performance and nudge our teams in the right
                  direction to improve their overall productivity.
                  <br />
                  Requesting you all to honest & unbiased feedback.
                </p>
                <input type="hidden" name="role_id" value={role_id} />
                <input type="hidden" name="candidate_id" value={candidate_id} />
                <input
                  type="hidden"
                  name="employeeArray"
                  value={data?.roleWorker
                    ?.map((item) => item.user_id)
                    .join(",")}
                />
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary me-2">
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={onClose}
                  aria-label="Close"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContributionForm;
